export default "__VITE_ASSET__Cv$gvJzE__"